'use strict';
var toPrimitive = require('../internals/to-primitive');
var isSymbol = require('../internals/is-symbol');

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/to-property-key.js
// module id = 530
// module chunks = 0